import { SeriesFilterKey, SeriesFilters } from "../types/types";

export const SERIES_FILTER_FIELDS: Array<{
	key: SeriesFilterKey;
	label: string;
}> = [
	{ key: "cordLengthInFeet", label: "Cord Length" },
	{ key: "solidsHandlingInInches", label: "Solids Handling" },
	{ key: "dischargeSizeInInches", label: "Discharge Size" },
	{ key: "phase", label: "Phase" },
	{ key: "volts", label: "Voltage" },
	{ key: "floatType", label: "Switch Type" },
];

export const emptySeriesFilters = (): SeriesFilters => ({
	cordLengthInFeet: "",
	solidsHandlingInInches: "",
	dischargeSizeInInches: "",
	phase: "",
	volts: "",
	floatType: "",
});
